<template>
  <div class="quiz_bt_area">
    <button class="quiz_bt close_bt" @click.prevent="clickHandler"><span>とじる</span></button>
  </div>
</template>

<script>
export default {
  name: 'QuizCloseButton',
  methods: {
    clickHandler () {
      this.$emit('closeClick')
    }
  }
}
</script>

<style scoped>
  .quiz_bt_area {
    text-align: center;
  }

  @media screen and (max-width: 767px) {
    .quiz_bt_area {
      width: 100%;
    }
  }

  .quiz_bt_area a {
    text-decoration: none;
  }

  .quiz_bt {
    width: 372px;
    margin: 20px auto;
    padding: 20px 24px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 27px;
    color: #fff;
    font-weight: bold;
    border: 1px solid #fff;
    font-size: 30px;
    line-height: 30px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    cursor: pointer;
  }

  @media screen and (min-width: 768px) {
    .quiz_bt {
      -webkit-box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.1);
    }
  }

  @media screen and (max-width: 767px) {
    .quiz_bt {
      -webkit-box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.1);
      width: 100%;
    }
  }

  .quiz_bt:hover {
    opacity: .8;
  }

  .quiz_bt > span {
    -webkit-box-flex: 2;
    -webkit-flex-grow: 2;
    -ms-flex-positive: 2;
    flex-grow: 2;
    font-weight: 500;
    font-size: 30px;
    letter-spacing: .05em;
  }

  @media screen and (max-width: 767px) {
    .quiz_bt > span {
      font-size: 20px;
    }
  }

  .close_bt {
    background: #8dc9ed;
  }

  .close_bt:before {
    content: "";
    background: url("../assets/quiz_icon_close_white.png") no-repeat center;
    background-size: contain;
    width: 36px;
    height: 36px;
  }

  .close_bt:after {
    content: "";
    width: 36px;
    height: 36px;
  }

</style>
